import { useCallback } from 'react';

import { LockboxStatus } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

interface Result {
  status?: string;
  statusTitle?: string;
}

const useGetReturnCheckStatus = () => {
  const { originalLockbox } = useLockboxDetailsStore();

  const getReturnCheckStatus = useCallback((): Result => {
    if ((originalLockbox?.lockboxStatus === LockboxStatus.APPROVED || originalLockbox?.lockboxStatus === LockboxStatus.PROCESSING)
      && originalLockbox?.details?.processingDecision?.type === LockboxStatus.VOID) {
      return { status: LockboxStatus.VOID, statusTitle: 'Voided'};
    }

    return { status: originalLockbox?.lockboxStatus, statusTitle: originalLockbox?.lockboxStatus };
  }, [originalLockbox?.lockboxStatus, originalLockbox?.details?.processingDecision?.type]);

  return { getReturnCheckStatus };
};

export default useGetReturnCheckStatus;
